import React from "react";
import "./pages/home.css";
import "./footer.css";

const Footer = () => {
  return <footer className="footer">© 2025 alzavision.ro  All rights reserved.</footer>;
};

export default Footer;